import { useQuery, UseQueryOptions } from 'react-query';
import { BranchesService } from '../../services';
import { IBranchWithDeliveryPoint } from '../../interfaces';

export const useBranchesWithDeliveryPoints = (query = {}, options?: UseQueryOptions<IBranchWithDeliveryPoint[], Error, IBranchWithDeliveryPoint[], ['branches-with-deliver-points', object]>) => {
  return useQuery<IBranchWithDeliveryPoint[], Error, IBranchWithDeliveryPoint[], ['branches-with-deliver-points', object]>(
    ['branches-with-deliver-points', query],
    async ({ queryKey }) => {
      const [, params] = queryKey;
      const result = await BranchesService.getBranchesWithDeliveryPoints(params);
      if (result.status === 200) return result.data.data;
      throw new Error(result.data as string);
    },
    { staleTime: 5 * 60 * 1000, ...options },
  );
};
